module.exports = __webpack_public_path__ + "static/media/1006135.d3a4c23f.png";